import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import React, { useEffect, useMemo, useState } from 'react';

import { useStyles } from './styles';

interface IProps {
  data?: any;
  translate?: any;
  type: string;
  setValue: (value: string, type: string) => void;
  value: string;
  autocomplete?: boolean;
  addWorkspace?: boolean;
  defaultValue?: any;
  isGroupSelected?: boolean;
}

const Dropdown: React.FC<IProps> = ({
  addWorkspace,
  data,
  translate,
  type,
  setValue,
  value,
  autocomplete,
  defaultValue,
  isGroupSelected,
}) => {
  const [selectedOption, setSelectedOption] = useState('');
  const classes = useStyles();

  const translateInfo = (id: string) => {
    let name = id;
    if (type === 'members') {
      const filtered = translate.filter((member: any) => member.memberId === id)[0];
      if (filtered) {
        name = `@${
          filtered.profile.displayName.length
            ? filtered.profile.displayName
            : filtered.profile.realName
        }`;
      }
    } else if (type === 'channels') {
      const filtered = translate.filter((channel: any) => channel.channelId === id)[0];
      if (filtered) {
        name =
          filtered.group && !isGroupSelected
            ? `#${filtered.name} - ${filtered.group}`
            : `#${filtered.name}`;
      }
    } else if (type === 'teams') {
      const filtered = translate.filter((group: any) => group.groupId === id)[0];
      if (filtered) {
        name = `${filtered.name}`;
      }
    } else {
      name = `Last ${id} days`;
    }
    return name;
  };

  const dropdownOptions = useMemo(() => {
    return (addWorkspace ? [{ id: `All-${type}` }, ...data] : data).map((d: any) => ({
      value: d.id,
      label: translate ? translateInfo(d.id) : d.id,
    }));
  }, [data]);

  useEffect(() => {
    if (dropdownOptions.length > 0) {
      if (!defaultValue) {
        setValue(dropdownOptions[0].value, type);
        setSelectedOption(dropdownOptions[0]);
      } else {
        // setValue(defaultValue, type);
        setSelectedOption(dropdownOptions.find((d: any) => d.value === defaultValue));
      }
    }
  }, [dropdownOptions, defaultValue]);

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setValue(event.target.value as string, type);
  };

  const handleAutocompleteChange = (event: React.ChangeEvent<any>, newValue: any) => {
    setSelectedOption(newValue);
    setValue(newValue.value, type);
  };

  return (
    <FormControl variant="outlined" className={classes.counterWrapper} color={'primary'}>
      {autocomplete && (
        <Autocomplete
          id={`autocomplete-${type}`}
          value={selectedOption}
          options={dropdownOptions}
          getOptionLabel={(option: any) => (option ? option.label : '')}
          renderOption={(option: any) => option.label}
          renderInput={params => <TextField {...params} label={type} variant="outlined" />}
          disableClearable
          classes={{
            focused: classes.focused,
            option: `autocomplete-${type}`,
          }}
          onChange={handleAutocompleteChange}
        />
      )}
      {!autocomplete && (
        <>
          <InputLabel id="demo-simple-select-outlined-label">{type}</InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={value}
            onChange={handleChange}
            label={type}
            inputProps={{
              className: classes.input,
              focused: classes.focused,
            }}
          >
            {data.map((d: any) => (
              <MenuItem value={d.id} key={`menuitem-${d.id}`}>
                {d.id === 'Workspace' ? 'Workspace' : translate ? translateInfo(d.id) : d.id}
              </MenuItem>
            ))}
          </Select>
        </>
      )}
    </FormControl>
  );
};

export { Dropdown };
